// Cleans a message body before CompanyCommunications puts it on the page
// (Cursor review 2026-10-15, critical: the server's regex cleaner missed
// `<img/onerror=…>`, and the page assigned the result as HTML). The browser
// parses it with a real HTML parser (DOMParser never runs scripts), then an
// allow-list keeps only formatting tags, drops every attribute not on the
// list, and keeps only http(s)/mailto/in-app links. Anything else is removed.

const DROP_WITH_CONTENT = new Set([
  'script', 'style', 'noscript', 'iframe', 'frame', 'frameset', 'object', 'embed',
  'applet', 'link', 'meta', 'base', 'form', 'input', 'button', 'select', 'textarea',
  'svg', 'math', 'template', 'video', 'audio', 'source', 'track', 'canvas', 'title', 'head',
]);

const ALLOWED_TAGS = new Set([
  'a', 'abbr', 'b', 'blockquote', 'br', 'caption', 'center', 'cite', 'code', 'col', 'colgroup',
  'dd', 'del', 'div', 'dl', 'dt', 'em', 'font', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i',
  'img', 'ins', 'li', 'mark', 'ol', 'p', 'pre', 'q', 's', 'small', 'span', 'strike', 'strong',
  'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul',
]);

const ALLOWED_ATTRS = new Set([
  'href', 'src', 'alt', 'title', 'style', 'width', 'height', 'align', 'valign', 'colspan',
  'rowspan', 'border', 'cellpadding', 'cellspacing', 'color', 'face', 'size', 'bgcolor', 'target', 'rel',
]);

function safeUrl(value: string, forImage: boolean): boolean {
  const v = value.trim().toLowerCase();
  if (v.startsWith('/') || v.startsWith('#')) return true;
  if (v.startsWith('https://') || v.startsWith('http://')) return true;
  if (!forImage && v.startsWith('mailto:')) return true;
  if (forImage && v.startsWith('cid:')) return true;
  return false;
}

function clean(node: Element): void {
  for (const child of Array.from(node.children)) {
    const tag = child.tagName.toLowerCase();
    if (DROP_WITH_CONTENT.has(tag)) { child.remove(); continue; }
    clean(child);
    if (!ALLOWED_TAGS.has(tag)) { child.replaceWith(...Array.from(child.childNodes)); continue; }
    for (const attr of Array.from(child.attributes)) {
      const name = attr.name.toLowerCase();
      const ok = ALLOWED_ATTRS.has(name)
        && !(name === 'style' && /expression|url\s*\(|javascript:/i.test(attr.value))
        && !((name === 'href' || name === 'src') && !safeUrl(attr.value, name === 'src'));
      if (!ok) child.removeAttribute(attr.name);
    }
    if (tag === 'a' && child.getAttribute('target') === '_blank') child.setAttribute('rel', 'noreferrer noopener');
  }
}

export function safeHtml(html: string): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  clean(doc.body);
  return doc.body.innerHTML;
}
